import module from '../module';

export class LocalForageServiceAdapter {

  constructor() {
    if (!window.localStorage) {
      throw new Error('Current browser does not support Local Storage');
    }
    this.localStorage = localStorage;

  }

  reinitialize() {
  }

  exists(key) {
    return new Promise((resolve, reject) => {
      resolve(!!this.localStorage.getItem(key));
    });
  }

  retrieve(key) {
    const result = this.localStorage.getItem(key);
    if (result === undefined || result == null) {
      return Promise.resolve(null);
    }

    try {
      const output = JSON.parse(result);
      return Promise.resolve(output);
    } catch (e) {
      return Promise.resolve(result);
    }
  }

  store(key, value) {
    this.localStorage.setItem(key, JSON.stringify(value));
    return Promise.resolve();
  }

  remove(key) {
    this.localStorage.removeItem(key);
    return Promise.resolve();
  }

  clear() {
    this.localStorage.clear();
    return Promise.resolve();
  }
}

module.service('LocalForageService', LocalForageServiceAdapter);



// WEBPACK FOOTER //
// ./src/modules/shared/services/storageService.js